'use client';

import { useEffect } from 'react';

import { hydrateUserProfileFromApi } from '@/providers/auth/hydrate-user-profile';
import { runSessionBootstrap } from '@/providers/auth/run-session-bootstrap';
import { startSessionSilentRefresh } from '@/utils/fetch/session-gate';
import { tryStartTrackerFromCachedDevice } from '@/utils/tracker';

/**
 * 应用启动后触发设备注册与游客登录链，不渲染任何 UI。
 * 与 bootstrap 并行尽早请求用户资料（依赖 cookie 时无需等待登录链完成）。
 */
export default function AuthSessionBootstrap() {
    useEffect(() => {
        startSessionSilentRefresh();
        tryStartTrackerFromCachedDevice().catch(() => {
            /* 首访无本地 device_id，由 establishSession 成功后 registerTrackerParams 放行 */
        });
        hydrateUserProfileFromApi().catch(() => {
            /* 无 cookie / token 时静默失败，登录链完成后会再拉一次 */
        });
        runSessionBootstrap().catch(err => {
            console.error('[AuthSessionBootstrap]', err);
        });
    }, []);

    return null;
}
